import Text from "../../../../components/ui/Text";
import { useTalkieWalkie } from "../../hooks/use-talkie-walkie";
import { ScreenType } from "../WalkieTalkie";
import historyImage from "../../assets/images/history.webp";
import backImage from "../../assets/images/back.webp";
import { useAudioEffects } from "../../../../hooks/use-audio-effects";
import transitionSound from "../../../../assets/audio/transition.wav";
import walkieConnectSound from "../../../../assets/audio/station-found.wav";

interface NavigationProps {
  className?: string;
  onFirstButtonClick?: () => void;
  onBackClick?: () => void;
}

interface ScreenMeta {
  title?: string | null;
  description?: string | null;
  navigateBackTo?: ScreenType | null;
}

const screenMetaData: Record<ScreenType, ScreenMeta> = {
  "radio-connect": {
    title: "Radio Connect",
    description: "Here and here",
    navigateBackTo: null,
  },
  menu: {
    title: null,
    description: null,
    navigateBackTo: "radio-connect",
  },
  logs: {
    title: "Logs",
    description: "Manage it",
    navigateBackTo: "settings",
  },
  players: {
    title: "Players List",
    description: "Manage it",
    navigateBackTo: "settings",
  },
  settings: {
    title: "Settings",
    description: "Adjust preferences",
    navigateBackTo: "menu",
  },
};

const buttonBaseClasses =
  "bg-[#566AFF29] p-[6px] rounded-xl hover:opacity-80 transition-opacity";

const Navigation = ({
  className,
  onFirstButtonClick = () => {},
  onBackClick = () => {},
}: NavigationProps) => {
  const { activeScreen, setActiveScreen } = useTalkieWalkie();
  const { playEffect } = useAudioEffects();
  const screenData = screenMetaData[activeScreen];

  if (!screenData) return null;

  return (
    <div className={`flex items-center justify-between space-x-2 ${className}`}>
      {/* Left Side: Title + Description */}
      <div>
        {screenData.title && (
          <Text size="xs" className="text-[#BEB9FF] !font-semibold leading-4">
            {screenData.title}
          </Text>
        )}
        {screenData.description && (
          <Text
            size="xxs"
            className="text-[#BEB9FF]/60 font-[400] tracking-tight"
          >
            {screenData.description}
          </Text>
        )}
      </div>

      {/* Right Side: Actions */}
      <div className="flex items-center space-x-1">
        <button
          title="History"
          className={buttonBaseClasses}
          onClick={() => {
            onFirstButtonClick();
            if (activeScreen !== "radio-connect")
              playEffect(walkieConnectSound);
          }}
        >
          <img src={historyImage} alt="History" className="w-[13px] h-[13px]" />
        </button>

        {screenData.navigateBackTo !== null && (
          <button
            title="Back"
            className={buttonBaseClasses}
            onClick={() => {
              setActiveScreen(screenData?.navigateBackTo as ScreenType);
              playEffect(transitionSound);
              onBackClick();
            }}
          >
            <img src={backImage} alt="Back" className="w-[13px] h-[13px]" />
          </button>
        )}
      </div>
    </div>
  );
};

export default Navigation;
